import React, { useEffect, useRef } from 'react';
import { Icons } from '../../../components/base/BootstrapComponents';
import Pagination from '../../../components/base/Pagination/Pagination';
import {
  addressFormatter,
  optionClassFormatter,
  statusNumberFormatterWithZone,
} from '../../../utils/formatters';
import {
  ActionsFormatter,
  battery1VoltageFormatter,
  battery2VoltageFormatter,
  lowerDoorFormatter,
  MoreFormatter,
  powerSupplyFormatter,
  upperDoorFormatter,
  WorkingStateFormatter,
  StatusFormatterWithProblem,
} from './ParkingFormatters';
import Grid from '../../../components/base/Grid/Grid';

export default function ParkingMeterGrid(props) {
  const {
    hostList,
    hostListMeta,
    handleLoadingHostList,
    loading,
    showOnMap = () => {},
    sort = [],
    changeSort = () => {},
  } = props;

  const columns = [
    {
      dataField: 'host',
      text: 'Номер паркомата',
      formatter: statusNumberFormatterWithZone,
      dataClassName: 'align-middle position-relative',
    },
    {
      dataField: 'zbx_address',
      text: 'Адрес факт. / юрид.',
      formatter: (address, item) => addressFormatter(address, false, null, false, () => showOnMap(item)),
      dataClassName: 'align-middle',
    },
    {
      dataField: 'status',
      text: 'Состояние',
      formatter: (_, item) => <StatusFormatterWithProblem item={item} />,
      dataClassName: 'align-middle',
    },
    {
      dataField: 'status',
      text: 'Работа устройства',
      formatter: (_, a) => (<WorkingStateFormatter item={a} />),
      disableSort: true,
      dataClassName: 'align-middle',
    },
    {
      dataField: 'error',
      text: 'Нижняя дверь',
      formatter: lowerDoorFormatter,
      disableSort: true,
      dataClassName: 'align-middle',
    },
    {
      dataField: 'error',
      text: 'Верхняя дверь',
      formatter: upperDoorFormatter,
      disableSort: true,
      dataClassName: 'align-middle',
    },
    {
      dataField: 'error',
      text: 'Напряж-е на 1 АКБ',
      formatter: battery1VoltageFormatter,
      disableSort: true,
      dataClassName: 'align-middle',
    },
    {
      dataField: 'error',
      text: 'Напряж-е на 2 АКБ',
      formatter: battery2VoltageFormatter,
      disableSort: true,
      dataClassName: 'align-middle',
    },
    {
      dataField: 'powerSupply',
      text: 'Питание',
      formatter: powerSupplyFormatter,
      disableSort: true,
      dataClassName: 'align-middle',
    },
    {
      dataField: '',
      text: 'Действие',
      formatter: (_, a) => (<ActionsFormatter item={a} />),
      disableSort: true,
      dataClassName: 'align-middle',
    },
    {
      dataField: '',
      text: <Icons customIcon icon="more-vert" className="more-vert" />,
      formatter: (_, a) => (<MoreFormatter item={a} />),
      disableSort: true,
      dataClassName: 'align-middle',
      headerClassName: 'text-center',
    },
  ];

  const parkingRef = useRef(null);

  useEffect(() => {
    if (parkingRef && parkingRef.current) {
      parkingRef.current.scrollTo(0, 0);
    }
  }, [hostListMeta.page]);

  return (
    <div className="parking-meter-table g-0">
      <div className="frame">
        <div className="sticky-table-wrapper custom-scroll-theme" ref={parkingRef}>
          <Grid
            sort={sort}
            changeSort={changeSort}
            loading={loading}
            className="parking-meter-grid"
            columns={columns}
            data={hostList}
            rowClassFormatter={item => optionClassFormatter(item.available_status)}
          />
        </div>
      </div>
      <Pagination meta={hostListMeta} list={hostList} handleChangeMeta={handleLoadingHostList} />
    </div>
  );
}
